import React, { FC, useMemo } from 'react';
import { createStyles, Grid, LinearProgress, Theme, withStyles } from '@material-ui/core';
import Rank from 'src/interfaces/api/Ranking';
import useRank from '../hooks/useRank';

const RankLinearProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 7,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
      borderRadius: 5,
      backgroundColor: '#1a90ff',
    },
  })
)(LinearProgress);

interface Props {
  rank: Rank;
  nextRank?: Rank;
  userPoints?: number;
}

const RankProgress: FC<Props> = ({ userPoints, rank, nextRank }) => {
  const rankPercent = useMemo(() => {
    if (userPoints) {
      if (nextRank) {
        const total = nextRank.points - rank.points;
        const current = userPoints - rank.points;
        return Math.floor((current * 100) / total);
      }
      return 100;
    }
    return 0;
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <RankLinearProgress variant='determinate' value={rankPercent} />
      </Grid>

      <Grid item xs={12}>
        <Grid container justifyContent='space-between'>
          <Grid item>{nextRank ? `Prochain grade - ${nextRank.name}` : ''}</Grid>
          <Grid item>{rankPercent} %</Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const RankProgressContainer: FC = () => {
  const { ranks, userRankIndex, userPoints } = useRank();

  const nextRank = useMemo(
    () => (undefined !== userRankIndex && userRankIndex + 1 < ranks.length ? ranks[userRankIndex + 1] : undefined),
    [ranks, userRankIndex]
  );

  if (undefined === userRankIndex) {
    return null;
  }

  return <RankProgress userPoints={userPoints} rank={ranks[userRankIndex]} nextRank={nextRank} />;
};

export default RankProgressContainer;
